import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';
import { Subscription } from 'rxjs';
import { LicenceRoleType } from '@enums/licence-role-type.enum';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit, OnDestroy {
    private authSub: Subscription;

    isAuth       : boolean;
    hasTutorial  : boolean;
    hasMonitoring: boolean;

    constructor(
        private authSrv: AuthService
    ) {}

    ngOnInit() {
        this.isAuth = this.authSrv.isAuth();
        this.initRole();
        this.initSubscriptions();
    }

    ngOnDestroy(): void {
        if(this.authSub)
            this.authSub.unsubscribe();
    }

    private initSubscriptions(): void {
        this.authSub = this.authSrv.authChanged
        .subscribe(authState => {
            this.isAuth = authState;
            this.initRole();
        });
    }

    private initRole(): void {
        const role         = this.isAuth ? this.authSrv.getAuthUser().role : undefined;
        this.hasTutorial   = this.isAuth && role !== LicenceRoleType.servicing;
        this.hasMonitoring = [LicenceRoleType.bzd, LicenceRoleType.bko, LicenceRoleType.bank].includes(role);
    }
}
